import { Box, IconButton, Typography } from '@mui/material';
import CustomTooltip from 'common/customTooltip';
import StyledTooltip from 'common/StyledTooltip';
import { overflowTooltipSx, overflowArrowSx, overflowPopperModifiers } from './overflowTooltipStyles';
import { useLocation } from 'react-router-dom';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { resolveSmartCardTitle } from './smartCardTitle';

const cardTitleText = (card, fallbackTitle = 'Report Title') =>
  resolveSmartCardTitle(card, fallbackTitle);

const CardTitle = ({
  card,
  showEye,
  titleRef,
  isTitleOverflowing,
  onEyeClick,
  containerSx,
  titleSx,
  eyeContainerSx,
  fallbackTitle,
}) => {
  const title = cardTitleText(card, fallbackTitle);
  const location = useLocation();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        alignSelf: 'stretch',
        ...containerSx,
      }}
    >
      <StyledTooltip title={title} disableHoverListener={!isTitleOverflowing} placement="bottom-end" tooltipSx={overflowTooltipSx} arrowSx={overflowArrowSx} popperModifiers={overflowPopperModifiers}>
        <Typography
          ref={titleRef}
          component="span"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '100%',
            ...titleSx,
          }}
        >
          {title}
        </Typography>
      </StyledTooltip>

      {showEye ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch',
            ...eyeContainerSx,
          }}
        >
          <CustomTooltip
            title={location.pathname === '/bi/hidden-smart-card' ? 'View' : 'Hide'}
            arrow
            padding="10px 16px"
            borderRadius="8px 0px 8px 8px"
            popperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [-9, -3]
                  }
                }
              ]
            }}>
            <IconButton onClick={onEyeClick} size="small" sx={{ p: 0 }} aria-label={location.pathname === '/bi/hidden-smart-card' ? 'view card' : 'hide card'}>
              {location.pathname === '/bi/hidden-smart-card' ? <IconEyeOff size={20} color="#001A47" /> : <IconEye size={20} color="#001A47" />}
            </IconButton>
          </CustomTooltip>
        </Box>
      ) : null}
    </Box>
  );
};

export default CardTitle;